export enum ReferenceTypes {
    case = 0,
    correspondence = 1
}